import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=3ad45e20"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports